<template>
    <div class="News">
        <div class="container">
            <div class="list-style" v-for="(item,index) in dataList" :key="index">
                <router-link :to="{ name: 'ActivityNewsDetail', query:{id:item.id}}" class="router">
                    <el-image :src="item.titleImage" fit="cover" class="pic3"></el-image>
                    <div class="content">
                        <h4>{{item.title}}</h4>
                        <p class="date2">{{item.createdAt}}</p>
                        <div class="description" v-html="item.content"/>
                        <NewsFunction :viewCount="item.viewCount" :messageCount="item.messageCount"/>
                    </div>
                </router-link>
            </div>
        </div>
        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
        </loading>
    </div>
</template>

<script>
    import NewsFunction from '@/components/NewsFunction.vue'

    export default {
        name: 'ActivityNews',
        components: {NewsFunction},
        data() {
            return {
                id: this.$route.query.id,
                dataList: [],
                isLoading: true
            }
        },
        created() {
            this.setupData();
        },
        methods: {
            setupData: function () {
                this.$http.fetch`GetOinActivityAnnouncementList${{
                    'id': parseInt(this.id),
                }}
                ${json => {
                    this.dataList = json.data;
                    this.isLoading = false
                }}`;
            },
        }
    }
</script>
<style lang="less" scoped src="../../less/activity.less"/>